import AdminLayout from '../../components/feature/AdminLayout';
import UsersTable from './components/UsersTable';

export default function UsersPage() {
  return (
    <AdminLayout>
      <UsersTable />
    </AdminLayout>
  );
}
